import { requestApi } from '../util/network'

// 获取当前店铺所有商品
export const getStoreGoods =
  (store_id,keyword='') =>
    requestApi(
      '/Store/getStoreGoods',
      'POST',
      {
        'store_id': store_id, // 所属店铺
        'keyword': keyword
      },
      'member' // 默认带TOKEN 返回的数据带购物车商品的数量
    )

// 获取当前店铺所有评价
export const getStoreRatings =
    (storeId) =>
      requestApi(
        '/Store/getStoreRatings',
        'POST',
        {
          'store_id': storeId // 所属店铺
        }
      )
// 获取当前店铺所有代金券
export const getStoreVoucher =
    (storeId) =>
      requestApi(
        '/Voucher/voucher_tpl_list',
        'POST',
        {
          'store_id': storeId, // 所属店铺
          'gettype': 'points'
        }
      )
// 领取取代金券
export const receiveVoucher =
    (tid) =>
      requestApi(
        '/Membervoucher/voucher_point',
        'POST',
        {
          'tid': tid
        },
        'member'
      )
// 获取当前店铺信息
export const getStoreInfo =
    (storeId, token, lng, lat) =>
      requestApi(
        '/Store/store_info',
        'POST',
        {
          'store_id': storeId, // 所属店铺
          'key': token,
          'longitude': lng,
          'latitude': lat,
        }
      )
// 记录流量统计
export const flowstat_record =
    (storeId,goodsId, controller) =>
      requestApi(
        '/Store/flowstat_record',
        'POST',
        {
          'store_id': storeId,
          'goods_id':goodsId,
          'controller_param': controller,
          'action_param':'index'
        }
      )

